import ScreenLoader from './ScreenLoader';

export type {IScreenLoaderProps} from './ScreenLoader';
export default ScreenLoader;
